<template lang="pug">
  footer
    .left
      #auth(v-if="isAuthenticated && member")
        component.customer(
          :is="memberComponent.is"
          v-bind="memberComponent.props"
        ) {{ member.company || member.name }}
    .right
      ShoppingCart
      Menu#footer-menu(k="footer-menu" :max-depth="1")
</template>

<script>
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

import { get } from '@/helpers';

export default {
  name: 'Footer',
  components: {
    Menu,
    ShoppingCart
  },
  computed: {
    userFormRoute() {
      let path;
      this.menus.forEach(menu => {
        const item = menu.menuItems.find(item => get(item, 'page.view') === 'UserForm');
        if (item && item.path && !path) {
          path = item.path;
          return;
        }
      });
      return path;
    },
    memberComponent() {
      let memberComponent = {
        is: 'span',
        props: {}
      };
      if (this.userFormRoute) {
        memberComponent.is = 'router-link';
        memberComponent.props.to = this.userFormRoute;
      }
      return memberComponent;
    },
    ...mapGetters({
      member: 'auth/member',
      isAuthenticated: 'auth/isAuthenticated',
      menus: 'menus',
      config: 'config'
    })
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply flex
    justify-content: space-between
    position: fixed
    bottom: 0
    background: rgba(255, 255, 255, .7)
    backdrop-filter: blur(30px)
    border-top: 1px solid var(--color-primary)
    width: 100%
    z-index: 999
    height: $footerHeight
  #auth .customer
    // line-height: 36px
    font-weight: bold
  #auth,
  nav#footer-menu
    // @apply mx-auto p-4 hidden
    display: none
    padding: 0 3rem
    height: 100%
    align-items: center
    position: relative
    justify-content: flex-end
    @screen lg
      display: flex
    ::v-deep
      ul
        & > li
          border: 0
          display: inline-block
          & + li
            &:before
              content: "/"
              margin: 0 2px
          &.active .tree-item a
            // background: var(--color-primary)
            // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
            // color: hsl(0, 0%, var(--switch))
          .tree-item
            display: inline-block
            a
              line-height: 1
              padding: 2px 4px
  .right
    display: flex
    align-items: center
</style>
